import { concat, join, map, merge, toPairs } from 'ramda'
import { BootstrapData, QueryString, Referral } from '../../types'
import isLoadedInAppView from '../../utils/isLoadedInAppView'

const buildReferralData = (
  isAndroid: boolean,
  referral: Referral | Record<string, never>
): Referral =>
  merge(
    {
      sourceId: '',
      id: 'DTAPPDL',
      clickId: isAndroid ? 'MWEBHPANDROID' : 'MWEBHPIOS'
    },
    referral
  )

const baseUrlAndroid = 'https://www.priceline.com/r/app/'
const baseUrlNoAndroid = 'https://offers.priceline.com/lrapp/'

export const getLink = (
  isAndroid: boolean,
  referral: Referral | Record<string, never>,
  clientGUID: string,
  pageId: string
) => {
  const { id, sourceId, clickId = '' } = buildReferralData(isAndroid, referral)
  const queryStringObject: QueryString = {
    channel: 'Display',
    product: 'App',
    theme: 'app_dl_install',
    refid: `${sourceId}${id}`,
    refclickid: clickId,
    PAGEID: pageId,
    ...(clientGUID && {
      subSiteId: clientGUID
    })
  }
  const baseUrl = isAndroid ? baseUrlAndroid : baseUrlNoAndroid

  return concat(
    concat(baseUrl, '?'),
    join('&', map(join('='), toPairs(queryStringObject)))
  )
}

const getTrafficInfo = (query: QueryString, referral: Partial<Referral>) => {
  const {
    id: cookieRefId = '',
    clickId: cookieClickId = '',
    sourceId: appRefSource = ''
  } = referral
  const { refid = '', refclickid = '' } = query

  const qsRefId =
    typeof refid === 'string' && Object.keys(refid).length > 0 ? refid : ''
  const qsClickId =
    typeof refclickid === 'string' && Object.keys(refclickid).length > 0
      ? refclickid
      : ''
  const isPaid =
    cookieRefId.indexOf('GOOGLECPC|MSN') > -1 ||
    qsRefId.indexOf('GOOGLECPC|MSN') > -1
  const isBranded =
    cookieClickId.indexOf('BRAND') > -1 || qsClickId.indexOf('BRAND') > -1

  const isBlackListed = ['PLHTLCOMBINED'].every(blacklistedRefId => {
    return (
      cookieRefId.indexOf(blacklistedRefId) >= 0 ||
      qsRefId.indexOf(blacklistedRefId) >= 0 ||
      cookieRefId.match(/\bCO/) ||
      qsRefId.match(/\bCO/) ||
      appRefSource.match(/\bCO/)
    )
  })

  return {
    isPaid,
    isBranded,
    isBlackListed
  }
}

export const shouldHideAppBanner = (
  data: BootstrapData,
  query: QueryString
) => {
  const { isCookieSetToHideAppBanner, isMobile, referral } = data
  const { isPaid, isBranded, isBlackListed } = getTrafficInfo(query, referral)
  return (
    isCookieSetToHideAppBanner ||
    isLoadedInAppView(query) ||
    !isMobile ||
    (isPaid && !isBranded) ||
    isBlackListed
  )
}

export const getPropsForAppBanner = (data: BootstrapData) => {
  const { referral, webstats, isMobile, isAndroid } = data

  return {
    referral: referral ?? {},
    clientGUID: webstats?.clientGUID ?? '',
    isMobile,
    isAndroid
  }
}
